export default {
  "content": "<path d=\"M9.836 3.117l.984-.984a1.094 1.094 0 111.547 1.547L6.173 9.874a2.627 2.627 0 01-1.107.66L3.5 11l.467-1.566c.124-.418.35-.799.66-1.107l5.209-5.21zm0 0l1.539 1.54m-.875 4.01v2.77c0 .725-.588 1.313-1.313 1.313H3.064a1.312 1.312 0 01-1.313-1.313V5.313C1.75 4.588 2.338 4 3.063 4h2.77\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "15",
    "viewBox": "0 0 14 15",
    "fill": "none"
  }
};